"use client";

import React, { useEffect } from "react";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, EffectCoverflow, Navigation, Pagination } from "swiper";
interface CarouselProps {
  images: {
    src: string;
    alt: string;
    name: string;
    position: string;
  }[];
  autoplayDelay?: number;
  showPagination?: boolean;
  showNavigation?: boolean;
}
export const CardCarousel: React.FC<CarouselProps> = ({
  images,
  autoplayDelay = 1500,
  showPagination = true,
  showNavigation = true
}) => {
  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .swiper {
        width: 100%;
        padding-bottom: 50px;
      }

      .swiper-slide {
        background-position: center;
        background-size: cover;
        width: 300px;
      }

      .swiper-slide img {
        display: block;
        width: 100%;
      }

      .swiper-pagination-bullet {
        background-color:rgb(17, 16, 16);
      }

      @media (prefers-color-scheme: dark) {
        .swiper-pagination-bullet {
          background-color: rgb(229, 229, 229);
        }
      }

      .swiper-3d .swiper-slide-shadow-left,
      .swiper-3d .swiper-slide-shadow-right {
        background: none;
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);
  return <section className="w-ace-y-4" data-sentry-component="CardCarousel" data-sentry-source-file="card-carousel.tsx">
      <div className="mx-auto w-full max-w-4xl rounded-[24px] border border-black/5 dark:border-neutral-700 p-2 shadow-sm md:rounded-t-[44px] bg-white dark:bg-neutral-900">
        <div className="relative mx-auto flex w-full flex-col rounded-[24px] border border-black/5 dark:border-neutral-700 bg-neutral-200/5 dark:bg-neutral-800/40 p-2 shadow-sm md:items-start md:gap-8 md:rounded-b-[20px] md:rounded-t-[40px] md:p-2">
          <div className="flex w-full items-center justify-center gap-4">
            <div className="w-full my-12">
              <Swiper spaceBetween={50} autoplay={{
              delay: autoplayDelay,
              disableOnInteraction: false
            }} effect={"coverflow"} grabCursor={true} centeredSlides={true} loop={true} slidesPerView={"auto"} coverflowEffect={{
              rotate: 0,
              stretch: 0,
              depth: 100,
              modifier: 2.5
            }} pagination={showPagination} navigation={showNavigation ? {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev"
            } : undefined} modules={[EffectCoverflow, Autoplay, Pagination, Navigation]} data-sentry-element="Swiper" data-sentry-source-file="card-carousel.tsx">
                {images.map((image, index) => <SwiperSlide key={index}>
                    <div className="size-full min-h-[400px] rounded-3xl bg-neutral-100 dark:bg-neutral-800 p-4 flex flex-col items-center text-center shadow-md">
                      <Image src={`/assets/images/team/${image.src}`} width={500} height={500} className="size-full rounded-xl" alt={image.alt} />
                      <div className="mt-8">
                        <p className="text-base font-semibold text-neutral-800 dark:text-neutral-100">{image.name}</p>
                        <p className="text-sm text-neutral-500 dark:text-neutral-400">{image.position}</p>
                      </div>
                    </div>
                  </SwiperSlide>)}
                {/* {images.map((image, index) => (
                  <SwiperSlide key={index}>
                    <div className="size-full min-h-[400px] rounded-3xl bg-neutral-100 p-4 flex flex-col items-center text-center shadow-md">
                      <Image
                        src={`/assets/images/team/${image.src}`}
                        width={200}
                        height={200}
                        className="size-full rounded-xl"
                        alt={image.alt}
                      />
                      <div className="mt-8">
                        <p className="text-base font-semibold text-neutral-900">{image.name}</p>
                        <p className="text-sm text-neutral-700">{image.position}</p>
                      </div>
                    </div>
                  </SwiperSlide>
                 ))} */}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </section>;
};